import React from 'react';
import { Style } from 'radium';

export default function RadiumStyles() {
  return (
    <Style
      rules={{
        '.Select-value': {
          width: '95%'
        }
      }}
    />
  );
}
